module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Variants")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.variants)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Simple")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example1)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Custom")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example2)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0 2em 2em"
    }
  }, [_c('p', [_vm._v("Modal with the most simple component")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "highlightjs",
      rawName: "v-highlightjs"
    }]
  }, [_c('code', {
    staticClass: "js",
    staticStyle: {
      "font-size": "0.9em",
      "padding": "1em"
    }
  }, [_vm._v(_vm._s(_vm.formatJS(_vm.example3)))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1228fbee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/docs.vue
// module id = 219
// module chunks = 1